import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseServiceV2 } from '@servicesv2';
import { ColecoesModaViewModel, ConsultarColecoesModaViewModel } from '../../models/confeccoes/ColecoesModaViewModel';
import { ConsultaPaginadaViewModel } from '../../model/model.api';

@Injectable()
export class ColecoesModaServiceV2 extends BaseServiceV2 {

  constructor(http: HttpClient) {
    super('ColecoesModa', http);
  }

  consultarColecoesModa(payload: ConsultarColecoesModaViewModel) {
    return this.postPaginatedAsPromise<ConsultarColecoesModaViewModel, ConsultaPaginadaViewModel<ColecoesModaViewModel>>(payload, 'consultarColecoesModa');
  }

}
